enum FeePaymentTypeEnum {
  ADJUSTMENT = 3,
  ADVANCE = 1,
  FINALPAYMENT = 4,
  INSTALLMENT = 2
}

export default FeePaymentTypeEnum;
